window.env = window.env || {};

const getEnv = key => {
  return window.env[key] || process.env[key];
};

const env = {
  REACT_APP_AMP_TOKEN: getEnv('REACT_APP_AMP_TOKEN'),
  REACT_APP_AMP_EXPERIMENT_TOKEN: getEnv('REACT_APP_AMP_EXPERIMENT_TOKEN'),
  REACT_APP_PALANTIR_URL: getEnv('REACT_APP_PALANTIR_URL'),
  REACT_APP_ACCOUNT_URL: getEnv('REACT_APP_ACCOUNT_URL'),
  REACT_APP_BACKEND_URL: getEnv('REACT_APP_BACKEND_URL'),
  REACT_APP_MITHRANDIR_URL: getEnv('REACT_APP_MITHRANDIR_URL'),
  REACT_APP_URL: getEnv('REACT_APP_URL'),
  REACT_APP_VERSION: getEnv('REACT_APP_VERSION'),
  REACT_APP_EXTERNAL_STATUS_URL: getEnv('REACT_APP_EXTERNAL_STATUS_URL'),
  REACT_APP_SALESFORCE_URL: getEnv('REACT_APP_SALESFORCE_URL'),
};

export default env;
